import LocationOnIcon from "@material-ui/icons/LocationOn";
import CountryList from "./CountryList";

export default {
  list: CountryList,
  icon: LocationOnIcon,
};
